export default __webpack_public_path__ + "static/MatthewBarton-439d2db8ef005bd364ae1d7c5388cb0a.jpg";